export const SURVEY_ACTIONS = {
    SURVEY_SET_ANSWER: "SURVEY_SET_ANSWER",
    SURVEY_SET_NEXT_QUESTION: "SURVEY_SET_NEXT_QUESTION",
    SURVEY_SET_PREVIOUS_QUESTION: "SURVEY_SET_PREVIOUS_QUESTION",
    SURVEY_CLEAR_DATA: "SURVEY_CLEAR_DATA",
    UPDATE_CURRENT_QUESTION: "UPDATE_CURRENT_QUESTION",
    SURVEY_SET_ANSWERS_WITH_MAP: "SURVEY_SET_ANSWERS_WITH_MAP",
    SURVEY_CHANGE_ANSWER_IN_OBJ: "SURVEY_CHANGE_ANSWER_IN_OBJ",
    SURVEY_CHANGE_ANSWER_WITH_ID: "SURVEY_CHANGE_ANSWER_WITH_ID"
};

export function setSurveyAnswer(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_SET_ANSWER,
        payload
    }
}

export function setSurveyAnswersWithMap(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_SET_ANSWERS_WITH_MAP,
        payload
    }
}

export function nextSurveyQuestion(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_SET_NEXT_QUESTION,
        payload
    }
}

export function prevSurveyQuestion(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_SET_PREVIOUS_QUESTION,
        payload
    }
};

export function clearSurveyData() {
    return {
        type: SURVEY_ACTIONS.SURVEY_CLEAR_DATA
    }
}

export function updateSurveyCurrentQuestion(payload) {
    return {
        type: SURVEY_ACTIONS.UPDATE_CURRENT_QUESTION,
        payload
    }
}

export function changeOriginalAns(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_CHANGE_ANSWER_IN_OBJ,
        payload
    }
}

export function changeAnswerWithId(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_CHANGE_ANSWER_WITH_ID,
        payload
    }

}